import { Dispatch } from "redux";
import { Payload } from "@neworbit/redux-helpers";
import { loadAndTrack } from "redux-request-loading";

import { OrgStructureDetailModel } from "@teamprevent/common/orgStructure/models";

import * as actions from "./actionTypes";
import { orgStructureApi } from "./orgStructureApi";

export type OrgStructureAction =
    ({ type: typeof actions.LOAD_ORGSTRUCTURES_SUCCESS } & Payload<OrgStructureDetailModel[]>)
    | ({ type: typeof actions.CLEAR_ORGSTRUCTURES });

export function loadCurrentUserOrgStructureLevelOne(customerId: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "loadOrgStructures", orgStructureApi.getAll(customerId, ""));
        dispatch(loadOrgStructuresSuccess(result));
        return result;
    };
}

export function loadOrgStructures({ customerId, parentOrgStructureId, orgStructureOneId, orgStructureTwoId, orgStructureThreeId, orgStructureFourId }:
    {
        customerId: string; parentOrgStructureId?: string; orgStructureOneId?: string; orgStructureTwoId?: string; orgStructureThreeId?: string;
        orgStructureFourId?: string; name?: string;
    }) {
    return async (dispatch: Dispatch) => {
        const orgStructureId = parentOrgStructureId || orgStructureFourId || orgStructureThreeId || orgStructureTwoId || orgStructureOneId;
        const result = await loadAndTrack(dispatch, "loadOrgStructures", orgStructureApi.getAll(customerId, orgStructureId));
        dispatch(loadOrgStructuresSuccess(result));
        return result;
    };
}

export const loadOrgStructuresSuccess = (payload: OrgStructureDetailModel[]): OrgStructureAction => ({
    payload,
    type: actions.LOAD_ORGSTRUCTURES_SUCCESS
});

export function clearOrgStructures() {
    return async (dispatch: Dispatch) => {
        dispatch(clearOrgStructuresSuccess());
    };
}

export const clearOrgStructuresSuccess = (): OrgStructureAction => ({
    type: actions.CLEAR_ORGSTRUCTURES
});
